import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useInvoicePayment, InvoicePayment } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<InvoicePayment>
      useData={useInvoicePayment}
      config={{
        ...moduleConfig,
        getDetailSections: (item) => getDetailSections(item, moduleConfig.utils.formatDate, moduleConfig.utils.formatCurrency),
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

